import { useState } from "react";
import { authenticatedFetch } from '@/services/auth/authenticatedFetch.js';

export const useStorePayslip = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const storePayslip = async (file, consultantUuid) => {
    if (!file) return;
    setLoading(true);
    setError(null);

    const formData = new FormData();
    formData.append("payslip", file);
    formData.append("consultantUuid", consultantUuid);

    try {
      const response = await authenticatedFetch(
        window.ENV.BACKEND_URL+"/api/secured/admin/payslip/payslipFile",
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error("Failed to store payslip");
      }

      const result = await response.json();
      setData(result);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return { storePayslip, loading, error, data };
};
